module.exports = __webpack_public_path__ + "assets/img/kindergarten-m.a660ede.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/kindergarten-m.jpg
// module id = 4ZqJ
// module chunks = 0